import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

export function ActionBox({ children, className }: PropsWithChildren<{ className?: string }>) {
  return <div className={twMerge("flex flex-row flex-wrap items-center gap-2", className)}>{children}</div>;
}
